export default __webpack_public_path__ + "static/media/grafema_2ndliferesin_01.5e4e2dc9.mp4";